/**
 * Asking before Nova closes with something unsaved.
 *
 * Any part of the window names a reason (`setCloseGuard("flow", "…")`) and
 * clears it when it no longer holds. In the desktop app the shell asks with a
 * native box when the window is closed (src-tauri/src/lib.rs, CloseGuard); in a
 * browser tab the browser's own "leave this page?" question stands in.
 */

import { isDesktop } from "../platform";

const reasons = new Map<string, string>();
let sent: string | null = null;

function message(): string | null {
  if (!reasons.size) return null;
  return [...reasons.values()].join("\n\n");
}

function onBeforeUnload(e: BeforeUnloadEvent) {
  if (!reasons.size) return;
  e.preventDefault();
  e.returnValue = "";
}

if (typeof window !== "undefined" && !isDesktop()) window.addEventListener("beforeunload", onBeforeUnload);

/** Hold the window open for `id` with `text`, or let it go (`null`). */
export function setCloseGuard(id: string, text: string | null) {
  if (text) reasons.set(id, text);
  else reasons.delete(id);
  const next = message();
  if (next === sent || !isDesktop()) {
    sent = next;
    return;
  }
  sent = next;
  void import("@tauri-apps/api/core").then(({ invoke }) => invoke("set_close_guard", { message: next })).catch(() => undefined);
}
